
import {Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import PaidDownloadButtons from "@/components/PaidDownloadButtons.vue";

@Component(
    {components: {PaidDownloadButtons}}
)
export default class DownloadTab30 extends Vue {
  toggleFlip() {
    document.querySelector("#download30").classList.toggle("flip");
  }
}
